<!-- Wrapper-->
<div id="wrapper">

  <!-- Left navigation bar -->
  <navigation></navigation>

  <!-- Main page wrapper -->
  <div id="page-wrapper" class="gray-bg">

    <!-- Top navigation -->
    <topnavbar></topnavbar>

    <!-- Main view/routes wrapper-->
    <div [hidden]="dynamicView.hasContent()">
      <router-outlet></router-outlet>
    </div>

    @if (dynamicView.document(); as document) {
      <section class="agentic-view" aria-label="Assistant generated view">
        <div class="agentic-view__toolbar">
          <span>Assistant view</span>
          <button type="button" class="btn btn-default btn-xs" (click)="dynamicView.dismiss()">
            <i class="fa fa-times" aria-hidden="true"></i>
            Close
          </button>
        </div>
        <div class="agentic-view__content">
          @defer (on immediate) {
            <rail360-catalog-document [document]="document" />
          } @loading (after 150ms; minimum 150ms) {
            <div class="agentic-view__loading">Preparing view...</div>
          }
        </div>
      </section>
    }

    <!-- Footer -->
    <footer></footer>
    <div kendoDialogContainer></div>

  </div>
  <!-- End page wrapper-->

</div>
<!-- End wrapper-->